import { SQLService } from '../../services/sql.service';
import { Flip } from '../../app.animations';
import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { ModalController, NavParams } from '@ionic/angular';
@Component({
  selector: 'ng-cheques-select-deduction',
  templateUrl: './select-deduction.page.html',
  styleUrls: ['./select-deduction.page.styl'],
  animations: [ Flip ]
})
export class SelectDeductionPage implements OnInit {
  constructor(
    private router: Router,
    public sql: SQLService,
    private route: ActivatedRoute,
    private navCtrl: ModalController,
    private params: NavParams,
    private location: Location
  ) {
    var s = params.get('selected');
    if(s)this.selected = s.split(',');
    this.multiple = params.get('select_multiple');
    this.router.events.subscribe((eve) => {
      if(eve instanceof NavigationEnd) this.get_deductions();
    });
  }
  count = -1;
  deductions = [];
  selected = [];
  multiple: boolean;
  output = new EventEmitter();
  ngOnInit() {
    this.get_deductions();
  }
  get_deductions(event?) {
    this.sql.fetch('Deductions',(e)=>{
      this.deductions = e;
      console.log(this.deductions);
      this.count = e.length;
      console.log(this.count,'deductions',this.deductions);
      setTimeout(()=>{ if (event) event.target.complete(); },1234);
    });
  }
  select(e) {
    if(this.multiple){
      this.toggle_item(e);
    } else {
      this.navCtrl.dismiss(e.deduction_id);
    }
  }
  done_multiple() {
    this.navCtrl.dismiss(this.selected.join(','));
  }
  toggle_item(item) {
    if( this.selected.includes(item.deduction_id) ) {
      this.deselect_item(item);
    } else {
      this.select_item(item);
    }
  }
  select_item(item) {
    console.log(item.deduction_id);
    this.selected.push(item.deduction_id);
  }
  deselect_item(item) {
    var new_selection=[];
    for(var i = 0; i < this.selected.length; ++i){
      if(this.selected[i]!=item.deduction_id){
        new_selection.push(this.selected[i]);
      }
    }
    this.selected = new_selection;
  }
  select_all() {
    var new_selection=[];
    for (var i = 0; i < this.deductions.length; ++i) {
      new_selection.push(this.deductions[i].deduction_id);
    }
    this.selected=new_selection;
  }
  deselect_all() {
   this.selected = []; 
  }
  select_none() {this.navCtrl.dismiss(-1);}
  add() {
    this.router.navigate(['folder','Deduction','New']);
    this.navCtrl.dismiss();
  }
  off() {
    // this.location.back();
    if(this.multiple){
      this.done_multiple();
     } else {
      this.navCtrl.dismiss();
     }
  }
}